import { fromJS } from 'immutable';

import {
  SET_MESSAGE,
  RESET_MESSAGE,
} from '../actions/messages';

const initialState = fromJS({
  messages: {},
});

export default function (state = initialState, action) {
  // console.log('action', action);
  switch (action.type) {
    case SET_MESSAGE:
      return state.setIn(['messages', action.name], fromJS({
        type: action.messageType,
        message: action.message,
      }));
    case RESET_MESSAGE:
      return state.setIn(['messages', action.name], fromJS({}));
    default :
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/messages.js